import { ApiService } from '../../../types/api';
import type { APIKey, CreatedAPIKey } from '../types';

export interface APISettingsApiContract {
  list(): Promise<APIKey[]>;
  create(name: string): Promise<CreatedAPIKey>;
  delete(client_id: string): Promise<void>;
}

declare module '../../../context/page-context' {
  interface Apis {
    APISettings: APISettingsApiContract;
  }
}

export class APISettingsApi extends ApiService implements APISettingsApiContract {
  public list(): Promise<APIKey[]> {
    return this.api.proxy<APIKey[]>({
      method: 'GET',
      path: '/v1/api-keys',
    });
  }

  public create(name: string): Promise<CreatedAPIKey> {
    return this.api.proxy<CreatedAPIKey>({
      method: 'POST',
      path: '/v1/api-keys',
      payload: {
        name: name,
      },
    });
  }

  public delete(client_id: string): Promise<void> {
    return this.api.proxy<void>({
      method: 'DELETE',
      path: '/v1/api-keys/{id}',
      params: {
        id: client_id,
      },
    });
  }
}
